import { SectionByMicroservice } from '../state/i18n'

export function isEquivalentSection(sectionA: SectionByMicroservice, sectionB: SectionByMicroservice): boolean {
  return sectionA.msName === sectionB.msName && sectionA.sectionName === sectionB.sectionName
}
